module.exports = __webpack_public_path__ + "img/comfortaa-v27-latin-300.8594adeb.svg";